import React, { useEffect, useState } from "react";
import hub1 from "../assets/hub1.webp";
import hub2 from "../assets/hub2.webp";
import hub3 from "../assets/hub3.webp";
import hub4 from "../assets/hub4.webp";
import { webEndPoint } from '../constants/globalConstants';
import { makeRequest } from "../services/api";
export default function TotalOrders() {    
    const [orderCount, setOrderCount] = useState(0);
    const [loading, setLoading] = useState(false);
    const leftCards = [
        {
            img: hub1,
            title: "Complete shopping Hub",
            price: "You can find a wide variety of products, services, and brands all in one convenient location",
        },
        {
            img: hub2,
            title: "Unbeatable Price & Quality ",
            price: "Best possible products at prices that competitors cannot match",
        },
    ];
    const rightCards = [
        {
            img: hub3,
            title: "Exclusive collection",
            price: "Unique and Varitey range of products that are specially curated and not widely available elsewhere",
        },
        {
            img: hub4,
            title: "One shop for Daily wear",
            price: "Destination where you can find everything you need for any occasion and daily wear",
        },
    ];
    const getOrderCount = async () => {
        setLoading(true);
        try {
            let url = webEndPoint + `dashboard/summary`;
            const response = await makeRequest("get", url);
            if (response) {
                setOrderCount(response.data?.total_orders);
            }
        } catch (err) {
            console.error(err);
            alert("Order not found");
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        getOrderCount();
    }, []);
    return (
        <div className="section-header">
            <div>
                <h2>Why Choose Us?</h2>
            </div>
            <div className="total-orders-section">
                <div className="stats-layout">
                    <div className="side-grid">
                        {leftCards.map((card, index) => (
                            <div key={index} className="image-card">
                                <img src={card.img} alt={card.title} />
                                <p>{card.title}</p>
                                <p>{card.price}</p>
                            </div>
                        ))}
                    </div>
                    <div className="center-card">
                        <h2>Little Smiles Delivered So Far 🩷</h2>
                        <p className="small-text">in Website</p>
                        <div className="orders-count">
                            {orderCount?.toLocaleString()}
                        </div>
                        <p>Trusted by thousands of happy customers</p>
                    </div>
                    <div className="side-grid">
                        {rightCards.map((card, index) => (
                            <div key={index} className="image-card">
                                <img src={card.img} alt={card.title} />
                                <p>{card.title}</p>
                                <p>{card.price}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}